import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { withRouter } from 'react-router';

import { bookAppointmentTimeSlot } from './actions';
import { getAppointmentId } from '../reservation/selectors';
import WaitingListBook from './components/WaitingListBook';
import redirectWhenPropAvailable from '../hoc/redirectWhenPropAvailable';

export default compose(
  connect(state => ({
    appointmentId: getAppointmentId(state),
  }), { bookAppointmentTimeSlot }),
  withRouter,
  lifecycle({
    componentDidMount() {
      this.props.bookAppointmentTimeSlot(this.props.params);
    },
  }),
  redirectWhenPropAvailable(
    'appointmentId',
    props => `/view-reservation/${get(props, 'appointmentId')}`,
  ),
)(WaitingListBook);



// WEBPACK FOOTER //
// ./src/app/confirmation/WaitingListBook.js